import React, { useState, useEffect } from 'react'
import {
    Box,
    Button,
    Modal,
    Typography,
    IconButton,
    TextField,
    MenuItem,
    FormControl,
    Select,
    FormHelperText
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import CircularProgress from '@mui/material/CircularProgress'
import { useSelector, useDispatch } from 'react-redux'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { subscribePersonalChauffeur } from '../../redux/slices/product'
import CancelIcon from '@mui/icons-material/Cancel'
import PaymentModes from "../../components/PaymentModesForHourly";
import PhoneInput from '../phoneInput'
import {
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    Autocomplete
} from '@mui/material'
import { getFleetCars } from '../../redux/slices/common'
import FleetData from '../../data/fleets.json'
import FormLabel from '../label'
import CtaButton from '../buttonWithArrow'
import { lockScroll, unlockScroll } from '../../utils/scrollLock'
import DynamicPillButton from '../buttonWithArrow/whatsappButton'
import AfterFormSubmit from '../investNow/AfterFormSubmit'
import { useRouter } from 'next/navigation'
import { countries } from '../../data/countries'

const pillInputSx = {
    "& .MuiOutlinedInput-root": {
        borderRadius: 999,
        bgcolor: "#fff",
    },
};


const style = {
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
        backgroundColor: "rgba(0,0,0,0.6)", // dimmed background
    },
    container: {
        position: "sticky",
        top: 0,
        zIndex: 1,
        px: { xs: 2, sm: 3 },
        py: 2,
        borderBottom: "1px solid #eee",
        bgcolor: "#fff",
    },
    header: {
        fontWeight: 700,
        fontSize: 24,
        mb: 2
    },
    closeBtn: { position: "absolute", top: 8, right: 8, width: 36, height: 36 },
    input: {
        width: '100%',
        mb: 2,
        backgroundColor: '#f3f3f3',
        borderRadius: '12px',
        input: {
            padding: '22px 14px'
        },
        '& .MuiFilledInput-root': {
            backgroundColor: '#f3f3f3',
            borderRadius: '12px',
            boxShadow: 'none',
            '&:before': {
                borderBottom: '0 !important' // removes the bottom underline
            },
            '&:after': {
                borderBottom: '0 !important' // removes the focus underline
            },
            '&:hover:before': {
                borderBottom: '0 !important'
            }
        },
        '& .MuiFormHelperText-root': {
            marginLeft: 0
        }
    },
    select: {
        width: '100%',
        mb: 2,
        backgroundColor: '#f3f3f3',
        borderRadius: '12px',

        '& .MuiFilledInput-root': {
            backgroundColor: '#f3f3f3',
            borderRadius: '12px',
            paddingTop: '12px',
            paddingBottom: '12px',
            '&:before, &:after, &:hover:before': {
                borderBottom: '0 !important'
            }
        },
        '& .MuiSelect-filled': {
            padding: '12px 14px',
            backgroundColor: '#f3f3f3'
        }
    },
    submitBtn: {
        background: 'linear-gradient(to right, #9CD0C9, #32788E)',
        color: '#fff',
        fontWeight: 600,
        borderRadius: '12px',
        fontSize: '16px',
        textTransform: 'none',
        mt: 2,
        py: 1.2
    },
    fileInputBox: {
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        // bgcolor: "#f3f3f3",
        borderRadius: 999,
        px: 2,
        py: 1.5,
        mb: 2,
        border: "1px solid #c4c4c4",
    },
    chooseBtn: {
        background: "linear-gradient(to right, #9CD0C9, #32788E)",
        color: "#fff",
        fontWeight: 600,
        borderRadius: "10px",
        fontSize: 13,
        px: 2,
        py: 0.75,
        textTransform: "none",
        "&:hover": {
            opacity: 0.95,
        },
    },
    fileRemoveBtn: {
        color: "#7bcbc4",
        "&:hover": { color: "#5fbab2" },
    },
}


export default function ActivateForm({
    open,
    setOpen,
    handleCloseEnquire,
    fleetCard = [],
    contact,
    setContact,
    handleSubmitting, selectedPlan, setSelectedPlan, onClose
}) {
    const dispatch = useDispatch();
    const router = useRouter();
    const { subscribePersonalChauffeurRes } = useSelector(state => state.product)
    const { fleetCarsState } = useSelector(state => state.common)
    const [statusMessage, setStatusMessage] = useState('')
    const [status, setStatus] = useState(null);
    const [enquiryOpen, setEnquiryOpen] = useState(false)

    const [vehicleInfo, setVehicleInfo] = useState([])
    const [loader, setLoader] = useState(false)
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        countryCode: '971',
        phone: '',
        payment: ''
    })

    const [errors, setErrors] = useState({})
    const [paymentOpen, setPaymentOpen] = React.useState(false);
    const [paymentMode, setPaymentMode] = React.useState("1");
    const [transRef, setTransRef] = React.useState(null);
    const [errorMessage, setErrorMessage] = React.useState(null);

    useEffect(() => {
        if (open) lockScroll();
        else unlockScroll();

        return () => unlockScroll(); // cleanup if component unmounts
    }, [open]);


    useEffect(() => {
        if (FleetData) {
            const data = FleetData

            const initialVehicleInfo = data.map(vehicle => ({
                id: vehicle?._id, // Use _id from the response as id
                name: vehicle?.name,
                initial: '',
                monthly: '',
                month: '',
                image: vehicle?.image
            }))

            const updatedVehicleInfo = initialVehicleInfo.map(vehicle => {
                const matchingApiResponse = data.find(
                    apiVehicle => apiVehicle._id === vehicle.id
                )
                if (matchingApiResponse) {
                    return { ...vehicle, name: matchingApiResponse.name }
                }
                return vehicle
            })

            setVehicleInfo(updatedVehicleInfo)
        }
    }, [FleetData])


    const handleCardOption = (data) => {
        handlePay();
    };

    const handleCancelPayment = () => {
        setPaymentOpen(false);
        setPaymentMode("1");
        setErrorMessage(null);
    };

    const resetForm = () => {
        setFormData({
            name: '',
            email: '',
            countryCode: '971',
            phone: '',
            vehicle: '',
            vehicleId: '',
            passport: null,
            license: null
        })
        setErrors({})
        setPaymentOpen(false);
    }

    const handleClickOpen = () => {
        // setOpen(false);
        setEnquiryOpen(true)
    }

    const handleClose = () => {
        // if (statusMessage === "") {
        //     window.location.reload();
        // }
        // resetForm();
        if (statusMessage === '' && subscribePersonalChauffeurRes?.status === 1) {
            setOpen(false)
        }
        setEnquiryOpen(false)
    }

    useEffect(() => {
        if (subscribePersonalChauffeurRes) {
            setLoader(false);
            if (subscribePersonalChauffeurRes?.paymentUrl && subscribePersonalChauffeurRes?.paymentUrl !== "") {
                sessionStorage.setItem("activityTypes", 21);
                sessionStorage.setItem("ref", subscribePersonalChauffeurRes?.orderReference);
                sessionStorage.setItem("carTripIs", subscribePersonalChauffeurRes?.subscriptionId);
                sessionStorage.setItem("activityTypes", 21);
                router.push(subscribePersonalChauffeurRes?.paymentUrl);
            } else {
                if (subscribePersonalChauffeurRes.status === 1) {
                    handleClickOpen()
                    resetForm()
                    setStatusMessage('')
                    setStatus(subscribePersonalChauffeurRes.status);
                } else {
                    handleClickOpen()
                    setStatusMessage(subscribePersonalChauffeurRes.message || `We’re sorry! Something went wrong. Please try again in a few moments.`)
                    setStatus(-1)
                }
            }
        }
    }, [subscribePersonalChauffeurRes])


    const validate = () => {
        const newErrors = {}
        if (!formData.name.trim()) newErrors.name = 'Name is required'
        else if (!/^[A-Za-z\s]+$/.test(formData.name))
            newErrors.name = 'Only letters and spaces allowed'

        if (!formData.email) newErrors.email = 'Email is required'
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
            newErrors.email = 'Enter a valid email address'

        if (!formData.phone) newErrors.phone = 'Phone number is required'
        else if (!/^\d{7,15}$/.test(formData.phone))
            newErrors.phone = 'Enter a valid phone number (7–15 digits)'

        // if (!formData.passport) newErrors.passport = 'Passport copy is required'
        // if (!formData.license) newErrors.license = 'Driving license is required'

        return newErrors
    }

    useEffect(() => {
        if (selectedPlan && selectedPlan?.actionType === 2) {
            setPaymentOpen(true);
        }
    }, [selectedPlan])

    const handleSubmit = async e => {
        e.preventDefault()

        const validationErrors = validate()
        setErrors(validationErrors)

        if (Object.keys(validationErrors).length > 0) {
            setStatusMessage('Please fix the errors before submitting.')
            return
        } else {
            setPaymentOpen(true);
        }


        // const payload = new FormData()
        // payload.append('name', formData.name)
        // payload.append('phone', formData.phone)
        // payload.append('countryCode', formData.countryCode)
        // payload.append('email', formData.email)


        // for (let pair of payload.entries()) {
        //     console.log(pair[0] + ': ', pair[1])
        // }

        // setStatusMessage('')
        // setLoader(true)
        // dispatch(subscribePersonalChauffeur(payload))

    }

    const handlePay = async e => {
        let obj = {}
        const rslkeyId = sessionStorage.getItem('rslkeyId');
        if (selectedPlan?.actionType === 2) {
            obj = {
                paymentType: Number(paymentMode),
                transRef: Number(paymentMode) === 2 ? transRef : null,
                planId: selectedPlan?._id,
                "isUpgrade": true,
                "upgradeAmount": selectedPlan?.remainingAmount,
                passengerId: Number(rslkeyId) ?? undefined
            }
        } else {
            obj = {
                name: formData.name,
                phone: formData.phone,
                countryCode: formData.countryCode,
                email: formData.email,
                paymentType: Number(paymentMode),
                transRef: Number(paymentMode) === 2 ? transRef : null,
                planId: selectedPlan?._id,
                passengerId: Number(rslkeyId) ?? undefined
            }
        }


        setStatusMessage('')
        setStatus(null);
        setLoader(true);
        dispatch(subscribePersonalChauffeur(obj))
        handleClose();
    }

    useEffect(() => {
        dispatch(getFleetCars())
    }, [])

    const handleEnquiryClose = () => {
        handleCloseEnquire()
        resetForm()
    }

    return (
        <>
            <Modal
                open={open}
                onClose={handleEnquiryClose}
                sx={style.modal}
                scroll='body'
            >
                {/* Shell */}
                <Box
                    sx={{
                        position: "relative",
                        width: 700,
                        maxHeight: { xs: "90vh", sm: "90vh" },   // <-- controls total modal height
                        bgcolor: "#fff",
                        borderTopLeftRadius: { xs: 12, sm: 16 },
                        borderTopRightRadius: { xs: 12, sm: 16 },
                        borderRadius: { sm: 4 },
                        boxShadow: "0 18px 60px rgba(0,0,0,.25)",
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                    }}
                >
                    <Box sx={style.container}>
                        <Typography sx={{ fontWeight: 800, fontSize: { xs: 18, sm: 22, md: 24 } }} className="jura">Activate</Typography>
                        <IconButton
                            onClick={handleEnquiryClose}
                            sx={style.closeBtn}
                            aria-label="Close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <Box
                        sx={{
                            px: { xs: 2, sm: 3 },
                            overflowY: "auto",
                            flex: 1,
                            // helps value label of slider not get clipped
                            "&& .MuiSlider-root": { overflow: "visible" },
                        }}
                    >
                        {
                            selectedPlan?.actionType === 2 ?
                                <Box sx={{ mt: 2 }}>
                                    <h5>{selectedPlan?.remainingPaymentInfo}</h5>
                                </Box>
                                : <Grid container spacing={2} sx={{ mt: 0 }}>
                                    <Grid item xs={12}>
                                        <FormLabel label="Name" required />
                                        <TextField
                                            fullWidth
                                            placeholder="Enter Name"
                                            name="name"
                                            value={formData.name}
                                            error={!!errors.name}
                                            helperText={errors.name}
                                            onChange={e => {
                                                const onlyLetters = e.target.value.replace(/[^a-zA-Z\s]/g, '')
                                                setFormData({ ...formData, name: onlyLetters })
                                            }}
                                            sx={pillInputSx}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormLabel label="Email" required />
                                        <TextField
                                            fullWidth
                                            placeholder='john@example.com'
                                            value={formData.email}
                                            name="email"
                                            error={!!errors.email}
                                            helperText={errors.email}
                                            onChange={e => setFormData({ ...formData, email: e.target.value })}
                                            sx={pillInputSx}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormLabel label="Phone" required />
                                        <Box sx={{ display: "flex", mb: 2 }}>
                                            {/* Country Code Selector */}
                                            {/* <Autocomplete
                                                disableClearable
                                                options={countries}
                                                getOptionLabel={(option) => `${option.code} (+${option.phone})`}
                                                filterOptions={(options, { inputValue }) =>
                                                    options.filter(
                                                        (option) =>
                                                            option.label.toLowerCase().includes(inputValue.toLowerCase()) ||
                                                            option.code.toLowerCase().includes(inputValue.toLowerCase()) ||
                                                            option.phone.includes(inputValue.replace("+", ""))
                                                    )
                                                }
                                                value={countries.find((c) => c.phone === formData.countryCode) || countries[0]}
                                                onChange={(e, value) => {
                                                    if (value) setFormData({ ...formData, countryCode: value.phone });
                                                }}
                                                sx={{
                                                    width: "35%",
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: "999px 0 0 999px",
                                                    },
                                                }}
                                                renderOption={(props, option) => (
                                                    <li {...props}>
                                                        <span style={{ marginRight: 8 }}>
                                                            {String.fromCodePoint(
                                                                ...[...option.code.toUpperCase()].map((c) => 127397 + c.charCodeAt())
                                                            )}
                                                        </span>
                                                        {option.code} (+{option.phone})
                                                    </li>
                                                )}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        sx={{
                                                            "& .MuiOutlinedInput-root": {
                                                                borderRadius: "999px 0 0 999px",
                                                            },
                                                        }}
                                                    />
                                                )}
                                            /> */}

                                            {/* Phone Number Input */}
                                            {/* <TextField
                                                fullWidth
                                                placeholder="Enter Phone"
                                                value={formData.phone}
                                                name="phone"
                                                onChange={e =>
                                                    setFormData({
                                                        ...formData,
                                                        phone: e.target.value.replace(/\D/g, '')
                                                    })
                                                }
                                                error={!!errors.phone}
                                                helperText={errors.phone}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: "0 999px 999px 0", // rounded right side
                                                        bgcolor: "#fff",
                                                    }
                                                }}
                                            /> */}

                                            <PhoneInput
                                                value={formData.phone}
                                                countryCode={formData.countryCode}
                                                onChange={(countryCode, phone) =>
                                                    setFormData((prev) => ({
                                                        ...prev,
                                                        countryCode,
                                                        phone,
                                                    }))
                                                }
                                                error={!!errors.phone}
                                                helperText={errors.phone}
                                                width="100%"
                                            />

                                        </Box>
                                    </Grid>

                                </Grid>
                        }



                        {paymentOpen &&
                            <PaymentModes
                                setPaymentMode={setPaymentMode}
                                setTransRef={setTransRef}
                                handleCardOption={handleCardOption}
                                paymentMode={paymentMode}
                                price={selectedPlan?.actionType === 2 ? selectedPlan?.remainingAmount : selectedPlan?.priceValue || 0}
                                handleClose={handleCancelPayment}
                                errorMessage={errorMessage}
                                setErrorMessage={setErrorMessage}
                                bookingLoader={loader}
                                paymentBottom={2}
                            />
                        }

                        {/* Footer (sticky) */}

                        {!paymentOpen && selectedPlan?.actionType !== 2 &&
                            <Box
                                sx={{
                                    position: "sticky",
                                    bottom: 0,
                                    zIndex: 1,
                                    px: { xs: 2, sm: 3 },
                                    py: { xs: 2, sm: 2 },
                                    borderTop: "1px solid #eee",
                                    bgcolor: "#fff",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: "16px",
                                    // justifyContent: "center",
                                    flexDirection: { xs: "column", sm: "row" }
                                }}
                            >
                                <CtaButton label="Submit" onClick={handleSubmit}
                                    loader={loader}
                                // disabled={!isValid}
                                />
                            </Box>
                        }
                    </Box>
                </Box>
            </Modal>

            <AfterFormSubmit open={enquiryOpen} status={status} message={statusMessage} onClose={() => {
                if (status === 1) {
                    onClose();
                }
                setEnquiryOpen(false);
            }} Catalog={statusMessage === ""} />

            {/* <Dialog
                open={enquiryOpen}
                // onClose={handleClose}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
            >
                <DialogContent>
                    <Grid container spacing={3}>
                        <Grid
                            item
                            md={12}
                            sx={{ position: 'absolute', right: '3px', top: '-23px' }}
                        >
                            <CancelIcon
                                onClick={handleClose}
                                style={{
                                    color: '#7bcbc4',
                                    cursor: 'pointer',
                                    fontSize: '26px'
                                }}
                            />
                        </Grid>
                        <Grid
                            item
                            md={12}
                            sx={{ display: 'flex', justifyContent: 'center' }}
                        >
                            <img
                                src={
                                    statusMessage === ''
                                        ? '/img/greenTick.png'
                                        : '/img/reject.png'
                                }
                                alt='Success'
                                width='100'
                            />
                        </Grid>
                        <Grid
                            item
                            md={12}
                            sx={{ display: 'flex', justifyContent: 'center' }}
                        >
                            <h3 style={{ fontWeight: '400', fontSize: '16px' }}>
                                {statusMessage === '' ? 'Thank You' : statusMessage}
                            </h3>
                        </Grid>
                        <Grid
                            item
                            md={12}
                            sx={{ display: 'flex', justifyContent: 'center' }}
                        >
                            <h3 style={{ fontWeight: '400', fontSize: '16px' }}>
                                {statusMessage === '' ? 'Our Team will contact you' : ''}
                            </h3>
                        </Grid>
                    </Grid>
                </DialogContent>
                {statusMessage === "" &&
                    <DialogActions className='m-auto'>
                        <Button
                            variant='outlined'
                            component='a'
                            href={`${process.env.IMAGE_BASE_URL}/images/userwebsite/investor/rsl-dubai-investmentguide.pdf`}
                            download='rsl-dubai-investmentguide.pdf'
                            target='_blank'
                        >
                            Download Catalog
                        </Button>
                    </DialogActions>
                }
            </Dialog> */}
        </>
    )
}


